export const ADD_SAMVERKANSPART_USERS = "ADD_SAMVERKANSPART_USERS";
export const CHANGE_REQUIRED_FIELDS = "CHANGE_REQUIRED_FIELDS";
export const SET_ARRANGEMANG_OVERVIEW = "SET_ARRANGEMANG_OVERVIEW";
export const ADD_ARR_ARTISTER = "ADD_ARR_ARTISTER";
export const CLEAR_ARR_ARTISTER = "CLEAR_ARR_ARTISTER";
export const ADD_NOTISER = "ADD_NOTISER";
export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const SET_CURRENTWIZARD_STEP = "SET_CURRENTWIZARD_STEP";
